export function shouldShowOrganizationName() {
    return false;
}

export function getOrganizationDisplayName(item) {
    return (
        item?.organizationName ||
        item?.organization?.organizationName ||
        ""
    );
}

export function getDisplayNameWithOrganization(item, name) {
    const organizationName = getOrganizationDisplayName(item);

    if (organizationName) {
        return `${name} - (${organizationName})`;
    }

    return name;
}

export function getCustomerDisplayName(customer, includeOrganization = false) {
    const customerName =
        customer?.customerName ||
        customer?.name ||
        "";

    if (includeOrganization) {
        return getDisplayNameWithOrganization(customer, customerName);
    }

    return customerName;
}
